import { createFileRoute, notFound } from "@tanstack/react-router";

import type { PracticeType } from "../../api/gen/model";
import { GuidePage } from "../../features/help/GuidePage";

/** The trades a guide is written for, checked by hand: a route's definition loads with the app, and the validation
 * library stays out of the first load (ADR 0099). */
const guideTrades: readonly string[] = [
  "architect",
  "interior_architect",
  "interior_designer",
] satisfies PracticeType[];

function isTrade(value: string): value is PracticeType {
  return guideTrades.includes(value);
}

export const Route = createFileRoute("/_app/help_/guides/$trade")({
  params: {
    parse: ({ trade }) => {
      if (!isTrade(trade)) {
        throw notFound();
      }
      return { trade };
    },
    stringify: ({ trade }) => ({ trade }),
  },
  component: function GuideRoute() {
    const { trade } = Route.useParams();
    return <GuidePage trade={trade} />;
  },
});
